import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useStoreActions, useStoreState } from '@mortgage-pos/ui/store'

import Spinner from './Spinner'
import { PlaidLink } from '../PlaidLink'
import { usePlaid } from './PlaidContext'
import incense from '@mortgage-pos/ui/incense'
import { cn } from '@mortgage-pos/ui/utils/cn'
import Button, { ButtonVariants } from '../Button'
import StarIcon from '@mortgage-pos/ui/assets/star-icon.svg'
import {
  Routes,
  TaskStatus,
  LoanPurpose,
  QuestionSetSlug,
} from '@mortgage-pos/types'

const Success = () => {
  const navigate = useNavigate()
  const { plaidModalOpen } = usePlaid()
  const answers = useStoreState((state) => state.answers.answers)
  const accounts = useStoreState((state) => state.plaid.accounts)
  const isLoading = useStoreState((state) => state.plaid.isLoading)
  const isMiniFlow = useStoreState((state) => state.questionnaire.isMiniFlow)
  const updatePlaidTaskStatus = useStoreActions(
    (state) => state.task.updatePlaidTaskStatus
  )
  const closeMiniFlow = useStoreActions(
    (state) => state.questionnaire.closeMiniFlow
  )
  const plaidAccountConnected = useStoreActions(
    (state) => state.tracking.plaidAccountConnected
  )

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      plaidAccountConnected()
    }
  }, [accounts, plaidAccountConnected])

  const finishClickHandler = async () => {
    if (isMiniFlow) {
      closeMiniFlow({})
    } else {
      try {
        await updatePlaidTaskStatus({
          status: TaskStatus.Completed,
        })
      } catch (error) {
        incense(error)
          .details({
            name: 'PlaidTaskUpdateError',
            message: 'Failed to update Plaid task status',
          })
          .error()
      }

      const questionSet =
        answers.loanPurpose === LoanPurpose.Purchase
          ? QuestionSetSlug.ApplyPurchase
          : QuestionSetSlug.ApplyRefinance
      navigate(`/${Routes.APP_1003}?question-set=${questionSet}`)
      window.location.reload()
    }
  }

  const nextCtaLabel = isMiniFlow ? 'Finish' : 'Next'

  return (
    <div
      className={cn('plaid-assets__content plaid-assets__flex-column', {
        'plaid-assets__hidden': plaidModalOpen,
      })}
    >
      <div className="plaid-assets__logo">
        <img src={StarIcon} alt="StarIcon" height={44} />
      </div>
      <div className="plaid-assets__header">
        <p className="plaid-assets__title plaid-assets__center">Success</p>
        <p className="plaid-assets__heading plaid-assets__center">
          You're now connected!
        </p>
        <p className="plaid-assets__description plaid-assets__center">
          The following accounts have been successfully connected!
        </p>
        {
          <div className="plaid-assets__accounts-list">
            {accounts.map((account) => (
              <div key={account.id} className="plaid-assets__account">
                <div className="plaid-assets__account-name">
                  <strong>[{account.type}]</strong>
                </div>
                <div className="plaid-assets__account-details">
                  <span className="plaid-assets__account-number">
                    **{account.accountNumber}
                  </span>
                  <span className="plaid-assets__bank-name">
                    {` with ${account.bankName}`}
                  </span>
                </div>
              </div>
            ))}
          </div>
        }
      </div>

      {isLoading && <Spinner />}

      <div className="plaid-assets__flex-column">
        <Button
          disabled={isLoading}
          className="plaid-assets__success-finish plaid-assets__center"
          onClick={finishClickHandler}
          variant={ButtonVariants.next}
          content={nextCtaLabel}
        />
        <PlaidLink
          variant={ButtonVariants.default}
          content={'Add another account'}
          modifierClass="plaid-assets__center"
          btnClassName="plaid-assets__cta-link plaid-assets__primary-color"
        />
      </div>
    </div>
  )
}

export default Success
